import { FamilyViewModel } from './family-view-model';

export class ChildRealtionshipViewModel extends FamilyViewModel{ 
    biologicalFamilyName: string='';
    adoptiveFamilyName: string ='';
    fosterFamilyName: string='';
    specialFamilyName: string='';
}